import { create } from 'zustand';
import type { LabResultResponse } from '../generated/openapi/befunde-api';

type UpdatedBefund = { id: string; befund: LabResultResponse };

type UpdatedBefundStore = {
  befund: UpdatedBefund | null;
  setBefund: (befund: UpdatedBefund) => void;
  clearBefund: () => void;
};

export const useUpdatedBefundStore = create<UpdatedBefundStore>(set => ({
  befund: null,
  setBefund: befund => set({ befund: befund }),
  clearBefund: () => set({ befund: null }),
}));
